import { render, staticRenderFns } from "./DataDotacion.vue?vue&type=template&id=25174862&scoped=true&"
import script from "./DataDotacion.vue?vue&type=script&lang=js&"
export * from "./DataDotacion.vue?vue&type=script&lang=js&"
import style0 from "./DataDotacion.vue?vue&type=style&index=0&id=25174862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25174862",
  null
  
)

export default component.exports